/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiMacroprojectsIdQueryResponse,
  GetApiMacroprojectsIdPathParams,
} from '../models/GetApiMacroprojectsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiMacroprojectsIdQueryResponseSchema } from '../zod/getApiMacroprojectsIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiMacroprojectsIdQueryKey = (
  id: GetApiMacroprojectsIdPathParams['id'],
) => [{ url: '/api/macroProjects/:id', params: { id: id } }] as const;

export type GetApiMacroprojectsIdQueryKey = ReturnType<
  typeof getApiMacroprojectsIdQueryKey
>;

/**
 * {@link /api/macroProjects/:id}
 */
export async function getApiMacroprojectsId(
  id: GetApiMacroprojectsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiMacroprojectsIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/macroProjects/${id}`,
    ...requestConfig,
  });
  return getApiMacroprojectsIdQueryResponseSchema.parse(res.data);
}

export function getApiMacroprojectsIdQueryOptions(
  id: GetApiMacroprojectsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiMacroprojectsIdQueryKey(id);
  return queryOptions<
    GetApiMacroprojectsIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiMacroprojectsIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiMacroprojectsId(id, config);
    },
  });
}

/**
 * {@link /api/macroProjects/:id}
 */
export function useGetApiMacroprojectsId<
  TData = GetApiMacroprojectsIdQueryResponse,
  TQueryData = GetApiMacroprojectsIdQueryResponse,
  TQueryKey extends QueryKey = GetApiMacroprojectsIdQueryKey,
>(
  id: GetApiMacroprojectsIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiMacroprojectsIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiMacroprojectsIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiMacroprojectsIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
